import { useQuery } from 'react-query';

import type { QueryFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

export type ExternalRobotUser = {
  uuid: string;
  externalSoftwareName: string;
  isConnected: boolean;
  accessToken: string | null;
};

type ExternalRobotUserParams = {
  uuid: string;
};

type QueryParams = {
  refresh: boolean;
};

const getUseGetExternalRobotUserKey = (
  params: ExternalRobotUserParams,
  query?: QueryParams,
) => ['externalRobotUser', params, query] as const;

export const useGetExternalRobotUser: QueryFunction<
  ExternalRobotUser,
  [ExternalRobotUserParams],
  ReturnType<typeof getUseGetExternalRobotUserKey>,
  QueryParams
> = (params, { queryOptions, requestOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Fix in PP-24289
    queryKey: getUseGetExternalRobotUserKey(params, query as QueryParams),
    queryFn: ({ signal }) => {
      return request(`/managed_integrations/robot_users/${params.uuid}`, {
        query,
        init: {
          signal,
          method: 'GET',
        },
      });
    },
  });
};
